import { Component, Input } from "@angular/core";
import { ErrorComponentBase } from "../error.decorator";
import { IMenu } from "app/types/menu";

export interface Error503PageComponent extends ErrorComponentBase { }
@Component({
    selector: "error-503-page-component",
    templateUrl: "../error.view.html",
    standalone: false
})
@ErrorComponentBase
export class Error503PageComponent {

  @Input() error: { [key: string]: any };
  @Input() home: IMenu = null;
  @Input() sections: IMenu[] = [];

  code: string = "503";
  subTitle: string = 'Service Unavailable';
  lead: string = `The service you requested is unavailable at this time. Please try again later.`

}
